import type { z } from 'zod'

type ZodConfig = NonNullable<Parameters<typeof z.config>[0]>
type ZodErrorMap = NonNullable<ZodConfig['customError']>
type ZodRawIssue = Parameters<ZodErrorMap>[0]

export function zodPtBrErrorMap(issue: ZodRawIssue): string {
  switch (issue.code) {
    case 'invalid_type': {
      if (issue.input === undefined || issue.input === null) {
        return 'Campo obrigatório'
      }
      return 'Tipo de valor inválido'
    }

    case 'too_small': {
      const min = issue.minimum as number
      if (issue.origin === 'string') {
        if (min === 1) return 'Campo obrigatório'
        return `Deve ter no mínimo ${min} caracteres`
      }
      if (issue.origin === 'array' || issue.origin === 'set') {
        return `Deve ter no mínimo ${min} ${min === 1 ? 'item' : 'itens'}`
      }
      return `Deve ser no mínimo ${min}`
    }

    case 'too_big': {
      const max = issue.maximum as number
      if (issue.origin === 'string') {
        return `Deve ter no máximo ${max} caracteres`
      }
      if (issue.origin === 'array' || issue.origin === 'set') {
        return `Deve ter no máximo ${max} ${max === 1 ? 'item' : 'itens'}`
      }
      return `Deve ser no máximo ${max}`
    }

    case 'invalid_format': {
      const format = (issue as Record<string, unknown>).format as string
      if (format === 'email') return 'E-mail inválido'
      if (format === 'url') return 'URL inválida'
      if (format === 'uuid' || format === 'uuidv4' || format === 'uuidv6' || format === 'guid')
        return 'Identificador inválido'
      if (format === 'datetime' || format === 'date') return 'Data inválida'
      if (format === 'time') return 'Hora inválida'
      return 'Formato inválido'
    }

    case 'invalid_value':
      return 'Opção inválida'

    case 'not_multiple_of':
      return `Deve ser múltiplo de ${issue.divisor}`

    case 'unrecognized_keys':
      return 'Campos não reconhecidos'

    case 'invalid_union':
    case 'invalid_key':
    case 'invalid_element':
      return 'Valor inválido'

    default:
      return 'Campo inválido'
  }
}
